import { render } from "./TeamIntro.vue?vue&type=template&id=803ff7fc&scoped=true"
const script = {}

import "./TeamIntro.vue?vue&type=style&index=0&id=803ff7fc&lang=scss&scoped=true"

import exportComponent from "E:\\LEIGH_STORE\\PROJECTS\\2-PROJECTS\\6-PIYOOK\\ICS-Digital\\1-Dominic-Projects\\7-football-earnings\\5-website\\footy-earnings\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803ff7fc"]])

export default __exports__